import React from "react";

function SoundOnIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 16 16">
            <g fill="#637590">
                <path
                    opacity=".3"
                    d="M11.957 10.766a.5.5 0 1 1-.488-.873 2.165 2.165 0 0 0 .014-3.777.5.5 0 0 1 .495-.87 3.165 3.165 0 0 1-.021 5.52z"
                />
                <path d="m5.747 10.667-2.262-.453a1.333 1.333 0 0 1-1.071-1.307V7.093c0-.635.448-1.183 1.071-1.307l2.262-.453 2.195-2.195a.667.667 0 0 1 1.138.472v8.78a.667.667 0 0 1-1.138.472l-2.195-2.195z" />
            </g>
            <defs>
                <clipPath id="5wmpyi06za">
                    <path fill="#fff" d="M0 0h16v16H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default SoundOnIcon;
